<script>
// import {gsap} from "gsap";
import TakeaBreakStepOne from "@/components/ThreeJs/SidebarPopup/TakeaBreak/TakeaBreakStep1.vue";
import LaunchTimeStepOne from "@/components/ThreeJs/SidebarPopup/TakeaBreak/LaunchTime/LaunchTimeStep1.vue";
import LaunchTimeStepTwo from "@/components/ThreeJs/SidebarPopup/TakeaBreak/LaunchTime/LaunchTimeStep2.vue";
import EventStepOne from "@/components/ThreeJs/SidebarPopup/TakeaBreak/Event/EventStep1.vue";
import EventStepTwo from "@/components/ThreeJs/SidebarPopup/TakeaBreak/Event/EventStep2.vue";
import TakeaBreakOutro from "@/components/ThreeJs/SidebarPopup/TakeaBreak/TakeaBreakOutro.vue";
import ControlsExplained from "@/components/ThreeJs/SidebarPopup/ControlsExplained/ControlsExplained.vue";
import {gsap} from "gsap";
import SidebarIntro from "@/components/ThreeJs/SidebarPopup/SidebarIntro.vue";

export default {
  name: "SidebarOrganizer",
  components: {
    SidebarIntro,
    ControlsExplained,
    TakeaBreakStepOne,
    TakeaBreakOutro,
    LaunchTimeStepOne,
    LaunchTimeStepTwo,
    EventStepOne,
    EventStepTwo
  },
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    mapVisible: {},
    sidebarOpened: {},
    getSmallPopupStep: {},
    isVolumeMuted: {},
  },
  watch: {
    mapVisible() {
      this.$nextTick(() => {
        this.getAvatar(this.formData.avatar);
      });
    },
    sidebarOpened(newVal) {
      if (newVal.opened === true) {
        this.currentStep = newVal.step;

      }
    },
    getSmallPopupStep(newVal) {

      this.currentStep = newVal;
    },
  },
  data() {
    return {
      selectedImage: null,
      currentStep: null,
      videoData: null,
      currentGsapTimeline: null,
      previousStep: null,
    }
  },
  beforeMount() {

  },
  mounted() {

  },
  methods: {
    getAvatar(avatar) {
      this.selectedImage = require(`@/assets/img/avatare/${avatar}.webp`);
    },
    nextStep(data) {
      this.currentStep = data;
    },
    goBack(data) {
      this.previousStep = data;
    },
    closeOverlay() {
      this.$emit('closeOverlay')
    },
    resetWebSpecial() {
      this.$emit('reset')
    },
    playVideo(data) {
      this.videoData = data.video;
      this.currentStep = data.step;
    },
    onEnter(el) {
      gsap.to(el, {
        display: "flex",
        opacity: 1,
        duration: 0.5
      });
    }
  }
}
</script>
<template>
  <transition-group
      name="step"
      @enter="onEnter"
     >
    <SidebarIntro
        v-if="currentStep === 0"
        @goBack="goBack"
        @reset="resetWebSpecial"
        @closeOverlay="closeOverlay"
        @nextStep="nextStep"
        :formData="formData"
        :mapVisible="mapVisible"
    >
    </SidebarIntro>

    <TakeaBreakStepOne
        v-if="currentStep === 1"
        @goBack="goBack"
        @closeOverlay="closeOverlay"
        @nextStep="nextStep"
        :formData="formData"
        :mapVisible="mapVisible"
    >
    </TakeaBreakStepOne>


    <LaunchTimeStepOne
        v-if="currentStep === 'launchTimeStep1'"
        @goBack="goBack"
        @nextStep="nextStep"
        @videoData="playVideo"
        @closeOverlay="closeOverlay"
        :formData="formData"
        :mapVisible="mapVisible"
    >
    </LaunchTimeStepOne>
    <LaunchTimeStepTwo
        v-if="currentStep === 'launchTimeStep2'"
        @goBack="goBack"
        @nextStep="nextStep"
        @playVideo="playVideo"
        @closeOverlay="closeOverlay"
        :formData="formData"
        :mapVisible="mapVisible"
        :videoData="videoData"
        :isVolumeMuted="isVolumeMuted"
    >
    </LaunchTimeStepTwo>
    <EventStepOne
        v-if="currentStep === 'eventStep1'"
        @goBack="goBack"
        @nextStep="nextStep"
        @videoData="playVideo"
        @closeOverlay="closeOverlay"
        :formData="formData"
        :mapVisible="mapVisible"
    >
    </EventStepOne>
    <EventStepTwo
        v-if="currentStep === 'eventStep2'"
        @goBack="goBack"
        @nextStep="nextStep"
        @playVideo="playVideo"
        @closeOverlay="closeOverlay"
        :formData="formData"
        :mapVisible="mapVisible"
        :videoData="videoData"
        :isVolumeMuted="isVolumeMuted"
    >
    </EventStepTwo>
    <TakeaBreakOutro
        v-if="currentStep === 'outro'"
        @closeOverlay="closeOverlay"
        @goBack="goBack"
        @nextStep="nextStep"
        @videoData="playVideo"
        :formData="formData"
        :mapVisible="mapVisible"
    >
    </TakeaBreakOutro>
    <ControlsExplained
        v-if="currentStep === 'controlsexplained'"
        @closeOverlay="closeOverlay"
        :formData="formData"
        :mapVisible="mapVisible"
    >

    </ControlsExplained>
  </transition-group>
</template>

<style lang="scss" scoped>
.three-js-container {
  width: 100vw;
  height: 100vh;

}

.takeabreakStep {
  * {
    pointer-events: none;
  }
}

.popup_content_right_container {
  display: flex;
  flex-direction: column;
}


.button {
  font-size: 22px;
}

.helpbutton {
  margin-top: auto !important;
}

.shortcut-menu_additionalcontent {
  display: flex;
  flex-direction: column;
  margin: 20px 0 0;
  gap: 0px !important;

  > div {
    display: flex;
    gap: 10px;
  }

  .button {
    margin: 0px;
  }
}


</style>

<style lang="scss" >
@import '@/assets/css/pages/takeabreak';
</style>
